import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { useMsal } from "@azure/msal-react";
import Autocomplete from "@mui/material/Autocomplete";
import Paper from "@mui/material/Paper";
import AutocompleteTextField from "../AutocompleteTextField/AutoCompleteTextField";
import { CarrierService } from "../../../services/CarrierService";
import { AlertContext } from "../../Dashboard/Dashboard";

export default function CarrierAutocomplete({
  label,
  title,
  titleSize,
  width,
  carrierId,
  defaultInput,
  selectedOption,
  updateSelectedCarrier,
  disabled,
  error
}) {
  const { instance } = useMsal();
  const [options, setOptions] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [selected, setSelected] = useState("");
  const { warning } = useContext(AlertContext);

  useEffect(() => {
    updateSelectedCarrier(selectedOption);

    if (!selectedOption) {
      setSearchInput("");
    }
  }, [selectedOption]);

  useEffect(() => {
    if (searchInput.length > 3) {
      const params = {
        ["carrierName"]: searchInput
      };

      setIsLoading(true);
      setTimeout(() => {
        CarrierService.FindCarrier(instance, params).then(res => {
          setOptions(res);
          if (searchInput && res.length === 1) {
            setSelected(res[0]);
          }
          setIsLoading(false);
        }).catch(error => {
          console.error(error);
          setIsLoading(false);
          warning(error);
        });
      }, 1);
    } else {
      setOptions([]);
    }
  }, [searchInput]);

  useEffect(() => {
    if (defaultInput) {
      setSearchInput(defaultInput);
    }
  }, [defaultInput]);

  useEffect(() => {
    if (carrierId) {
      setTimeout(() => {
        CarrierService.GetCarrier(instance, carrierId).then(res => {
          setSelected(res);
        }).catch(error => {
          console.error(error);
          warning(error);
        });
      }, 1);
    }
  }, [carrierId]);

  useEffect(() => {
    updateSelectedCarrier(selected);
  }, [selected]);

  return (
    <Autocomplete
      id={`autocomplete-${label}`}
      freeSolo
      autoHighlight
      disabled={disabled}
      value={selectedOption}
      onChange={(event, newValue) => {
        updateSelectedCarrier(newValue);
      }}
      options={options}
      filterOptions={(x) => x}
      sx={{
        width: width,
        "& .MuiOutlinedInput-root": {
          padding: "1.5px 39px 1.5px 0 !important",
        }
      }}
      inputValue={searchInput}
      PaperComponent={
        ({ children }) =>
          <Paper sx={{
            backgroundColor: "black_solid.10",
            fontSize: "body1.fontSize",
            fontWeight: "body1.fontWeight",
            boxShadow: "elevation1"
          }}
          >
            {children}
          </Paper>
      }
      onInputChange={(event, newInputValue) => {
        setSearchInput(newInputValue);
      }}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={option =>
        option && `${option.id} - ${option.name}`
      }
      renderInput={(params) =>
        <AutocompleteTextField
          label={label}
          title={title}
          titleSize={titleSize}
          isLoading={isLoading}
          searchInput={searchInput}
          selected={selectedOption}
          params={params}
          error={error}
        />
      }
    />
  );
}

CarrierAutocomplete.propTypes = {
  label: PropTypes.string,
  title: PropTypes.string,
  titleSize: PropTypes.string,
  width: PropTypes.string,
  carrierId: PropTypes.string,
  defaultInput: PropTypes.string,
  selectedOption: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  updateSelectedCarrier: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
};